import { render, staticRenderFns } from "./AppSideInfo.vue?vue&type=template&id=2fd3663a"
import script from "./AppSideInfo.vue?vue&type=script&lang=js"
export * from "./AppSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports